<template>
	<div>
		<div class="imagecontainer">
			<img src="../assets/Contactus.png" style="width: 760px;height: 96px;"/>
		</div>
		<div class="imagecontainerone">
			<img src="../assets/We.png" style=" width: 1000px;height: 74px;"/>
		</div>
		
		<div class="search">
			<el-input placeholder="" v-model="email" class="input-with-select">
			    <el-button slot="append" icon="" class="btn" @click="submit()">Submit</el-button>
			</el-input>
		</div>
		
		<nav class="navbar">
		      <ul class="nav-list" >
		        <li class="nav-item" v-for="(item,index) in tabsList" :key="index">
					<img src="../assets/Group.png" style="width: 166px;height: 48px;"/>
					<div class="about">{{item.name}}</div>
					<div v-show="index==0" class="content" @click="Jump('HelloNovel')">HelloNovel</div>
					<div v-show="index==0" style="margin-top: 10px;" class="content" @click="Jump('Company')">Company</div>
					<div v-show="index==0" style="margin-top: 10px;" class="content">Privacy policy</div>
					<div v-show="index==0" style="margin-top: 10px;" class="content">Terms of service</div>
					<div v-show="index==1" class="content" @click="Jump('Author Recruitment')">Author Recruitment</div>
					<div v-show="index==2" class="content" @click="Jump('Contact Information')">Contact Information</div>
				</li>
				
		      </ul>
		</nav>
	</div>
</template>

<script>
	export default {
		data(){
			return{
				email:'',
				tabsList:[{name:'About us'},{name:'Join us'},{name:'Contact us'},{name:'Stay tuned...'}]
			}
		},
		
		methods:{
			submit(){
				this.$message('success');
			},
			Jump(val){
				this.$emit('message-from-child', val);
			}
		}
	}
</script>

<style scoped="scoped">
	
	/deep/.el-input__inner{
		border: 3px solid #FF973C !important;
		border-radius: 13px;
		height: 51px;
		line-height: 51px;
	}
	
	/deep/.el-input-group__append{
		border-radius: 13px;
		border: 3px solid #FF973C;
		border-top-left-radius: 0;
		border-bottom-left-radius: 0;
		border-left: 0;
		background-color: #FF973C;
		font-weight: 900;
		font-size: 22px;
		color: #FFFFFF;
	}
	
	.imagecontainer {
	  display: flex;
	  justify-content: center;
	  padding-top: 20px;
	  
	}
	
	.imagecontainerone {
	  display: flex;
	  justify-content: center;
	  padding-top: 50px;
	}
	
	.search{
		display: flex;
		justify-content: center;
	}
	
	.input-with-select{
		margin-top: 62px;
		width: 700px !important;
	}
	
	.btn{
		/* background-color:#FF973C !important; */
		font-family: Inter, Inter;
		font-weight: 900;
		font-size: 22px;
		height: 51px;
		color: #FFFFFF !important;
	}
	.navbar {
	  overflow: hidden;
	  position: absolute;
	  bottom: 0;
	  left: 0;
	  right: 0;
	  margin: auto;
	  width: 100%; 
	  padding-bottom: 150px;
	}
	
	.nav-list {
	  list-style-type: none; 
	  margin: 0;
	  padding: 0;
	  display: flex;
	  justify-content: center;
	}
	
	.nav-item {
	  float: left; 
	  padding: 20px 30px;
	}
	
	.about{
		margin-top: -38px;
		font-family: Inter, Inter;
		font-weight: bold;
		font-size: 19px;
		color: #FFFFFF;
	}
	
	.content{
		margin-top: 20px;
		font-family: Inter, Inter;
		font-weight: normal;
		font-size: 13px;
		color: #606060;
	}
</style>